/**
 * Created by neo on 18.08.23
 */
import { makeAutoObservable } from 'mobx';
import { LocalizedValue, createLocalizedValue } from '../LocalizedValue';
import { languagePriority } from '../LocalizedNamedEntity';

export type FormFieldType = 'numeric' | 'string' | 'email' | 'date' | 'datetime' | 'time' | 'boolean';

export type FormFieldJson = {
  identifier: string;
  label: LocalizedValue[];
  value: any | undefined;
  minSize: number | undefined;
  maxSize: number | undefined;
  valueType: FormFieldType;
};

export type FormField = FormFieldJson & {
  readonly defaultLabel: string;
  getLabel(lang: string): string;
};

export function createFormField(json?: Partial<FormField>): FormField {
  return makeAutoObservable({
    identifier: json?.identifier ?? '',
    label: (json?.label ?? []).map((l: any) => createLocalizedValue(l)),
    value: json?.value ?? '',
    minSize: json?.minSize,
    maxSize: json?.maxSize,
    valueType: json?.valueType ?? 'string',

    get defaultLabel(): string {
      for (const lang of languagePriority) {
        const entry = this.label.find((l) => l.lang === lang);
        if (entry) return entry.value ?? '';
      }
      return this.label[0]?.value ?? '';
    },

    getLabel(lang: string): string {
      return this.label.find((n) => n.lang === lang.toLowerCase())?.value || this.defaultLabel;
    },
  });
}
